/**
 * The panes of the automation settings: the general settings of the whole
 * automation (trigger, sharing in the Hub, history) and one pane per step.
 * Each sidebar card opens exactly one pane.
 */
import {
  READINESS_GROUPS,
  readinessGroupOf,
  type ReadinessStep,
  type ReadinessTileId,
} from './automation-readiness';

export type SettingsPane = 'general' | ReadinessStep;

/** The setting each pane opens at when nothing in it is open. */
export const PANE_PRIMARY_TILE: Record<SettingsPane, ReadinessTileId> = {
  general: 'trigger',
  input: 'source',
  workflow: 'workflow',
  output: 'target',
};

export const paneOfTile = (tile: ReadinessTileId): SettingsPane => {
  const group = readinessGroupOf(tile);
  return group === 'trigger' || group === 'history' ? 'general' : group;
};

export const tilesOfPane = (pane: SettingsPane): readonly ReadinessTileId[] =>
  READINESS_GROUPS.filter(group =>
    pane === 'general'
      ? group.id === 'trigger' || group.id === 'history'
      : group.id === pane
  ).flatMap(group => group.tiles);
